import { FanClockIcon } from './FanClockIcon';

/**
 * author: Michael Irigoyen
 * id BF3F7855-4971-4FA7-9BB8-8ED99E697D7A
 * name fan-clock
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/fan-clock.svg
 * tags
 * - Home Automation 
 * - Date / Time 
 */
export const FanTimerIcon = FanClockIcon;
export default FanTimerIcon